var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import AntDropdown from "antd/es/dropdown";
import { useGetGerudoContainer } from "../hooks/useGetGerudoContainer";
export const Dropdown = (_a) => {
    var { children, className, overlay } = _a, props = __rest(_a, ["children", "className", "overlay"]);
    const classes = classNames("gerudo-dropdown", className);
    const { ref: dropdownRef, getGerudoContainer } = useGetGerudoContainer();
    return (React.createElement("div", { className: classes, ref: dropdownRef },
        React.createElement(AntDropdown, Object.assign({ getPopupContainer: () => {
                return dropdownRef.current || getGerudoContainer();
            }, overlay: overlay }, props), children)));
};
Dropdown.propTypes = {
    children: PropTypes.node.isRequired,
    arrow: PropTypes.bool,
    className: PropTypes.string,
    overlayClassName: PropTypes.string,
    overlayStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    placement: PropTypes.oneOf(["bottomLeft", "bottomCenter", "bottomRight", "topLeft", "topCenter", "topRight"]),
    trigger: PropTypes.oneOf(["click", "hover", "contextMenu"]),
    visible: PropTypes.bool,
    disabled: PropTypes.bool,
    overlay: PropTypes.node.isRequired,
};
export default Dropdown;
//# sourceMappingURL=index.js.map